// extracted by mini-css-extract-plugin
module.exports = {"h4":"styles_h4__tqvHa","body":"styles_body__3wVsr","actions":"styles_actions__2_2jJ","form":"styles_form__3jCtt","footer":"styles_footer__3mu7i"};